import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-pause",
  "use": "icon-icon-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-pause\"><path d=\"M183.15 64.146l659.383 384.732a73.143 73.143 0 0 1 0 126.317L183.15 959.854a73.143 73.143 0 0 1-110.007-63.196V127.342A73.143 73.143 0 0 1 183.15 64.146z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol